import React from 'react'

export const EmptyCourseListIcon = () => (
  <svg width={198} height={197}>
    <g fill="none" fillRule="evenodd">
      <circle
        cx="98.5"
        cy="98.5"
        r="98.5"
        fill="#F4F4F4"
        transform="translate(1)"
      />
      <g transform="translate(1 83)">
        <rect width={57} height={42} fill="#E8E8E8" rx={5} />
        <path
          fill="#C6C6C6"
          d="M0 29.7V5a5 5 0 0 1 5-5h47a5 5 0 0 1 5 5v24.7H0z"
        />
      </g>
      <g transform="translate(71 83)">
        <rect width={57} height={42} fill="#E8E8E8" rx={5} />
        <path
          fill="#C6C6C6"
          d="M0 29.7V5a5 5 0 0 1 5-5h47a5 5 0 0 1 5 5v24.7H0z"
        />
      </g>
      <g transform="translate(141 83)">
        <rect width={57} height={42} fill="#E8E8E8" rx={5} />
        <path
          fill="#C6C6C6"
          d="M0 29.7V5a5 5 0 0 1 5-5h47a5 5 0 0 1 5 5v24.7H0z"
        />
      </g>
      <path
        stroke="#0189FF"
        strokeLinecap="round"
        strokeWidth={8}
        d="M98.5 34.5v29.014m58.713-20.807l-20.516 20.516m-74.484-.01L41.697 42.697"
      />
      <path
        stroke="#C6C6C6"
        strokeLinecap="round"
        strokeWidth={7}
        d="M3.943 175.5h190.465"
      />
      <circle cx={28} cy={175} r={11} fill="#999" />
      <circle cx={99} cy={175} r={11} fill="#999" />
      <circle cx={170} cy={175} r={11} fill="#999" />
    </g>
  </svg>
)
